export const STARTER_NODE_UI_ID = "ui-starter-node";

export const FLOW_STORAGE_KEY_PREFIX = "workflow-";

export const NODE_TYPES = {
  ASSIGN: "assignNode",
  SWITCH: "switchNode",
  STARTER: "starterNode",
  EMAIL: "emailNode",
};

export const NODE_LABELS = {
  [NODE_TYPES.ASSIGN]: "Assign",
  [NODE_TYPES.SWITCH]: "Switch",
  [NODE_TYPES.STARTER]: "Start",
  [NODE_TYPES.EMAIL]: "Email",
};

export const STARTER_NODE_POSITION = { x: 400, y: 0};
export const DEFAULT_NODE_POSITION = { x: 400, y: 150 };

export const EDGE_STYLES = {
  STARTER_EDGE: { stroke: "#1e3a8a" },
};

export const SOURCE_HANDLES = {
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right",
  POSITIVE: "positive",
  NEGATIVE: "negative",
};

/**
 * Output nodes that can only receive connections (terminal nodes)
 * These nodes have only input handles and no output handles
 * Add new output node types here to enable them for assignment node's right handle
 */
export const OUTPUT_NODES = [NODE_TYPES.EMAIL];
